import './styles/@theme';
import { classes } from '@/utils/classes/classes';
import { SvgLoader } from '@/app/elements/svg/loader';

export type MultiZoneTabButtonProps = {
    title: string;
    icon?: 'new' | null;
    isSelected: boolean;
    onClick: () => void;
};

export const MultiZoneTabButton: React.FC<MultiZoneTabButtonProps> = ({ title, icon, isSelected, onClick }) => {
    const selectedClassName = isSelected && 'selected-tab';

    return (
        <div className="multi-zone-tab-button">
            <button className={classes(selectedClassName, 'tab-button')} onClick={onClick}>
                {icon && <SvgLoader iconName={`zone-${icon}-tag`} className={classes(selectedClassName)} />}
                <div className="multi-zone-tab-button__text">{title}</div>
            </button>
        </div>
    );
};
